module.exports = __webpack_public_path__ + "static/media/time_icon.b9d2bb4d.svg";